import React from "react";
import PropTypes from 'prop-types';

const MatchCalendar = ({ match, equipes, winScore = 2 }) => {
    const team1Data = equipes.find(e => e.teamtag === match.team1);
    const team2Data = equipes.find(e => e.teamtag === match.team2);
    const team1Lost = match.score2 === winScore;
    const team2Lost = match.score1 === winScore;

    const formatDate = (dateStr, timeStr) => {
        const date = new Date(`${dateStr}T${timeStr}`);
        return {
            date: date.toLocaleDateString('fr-FR', { weekday: 'short', month: 'short', day: 'numeric' }),
            time: date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
        };
    };

    const { date, time } = formatDate(match.date, match.time);

    return (
        <div className="space-y-2">
            <div className="text-sm text-gray-400 font-semibold">
                {date} • {time}
            </div>
            <div className="bg-[#1A1A1A] bg-opacity-70 rounded-lg p-4 backdrop-blur-sm border border-gray-700 hover:border-gray-500 transition-all">
                <div className="flex items-center justify-between">
                    <div className={`flex-1 flex items-center gap-2 md:gap-3 ${team1Lost ? 'opacity-50' : ''}`}>
                        {team1Data ? (
                            <>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/equipes/${team1Data.logo}`}
                                    alt={team1Data.name}
                                    className="w-8 h-8 md:w-12 md:h-12 rounded-md object-contain flex-shrink-0"
                                    onError={(e) => e.target.style.display = 'none'}
                                />
                                <div className="text-left min-w-0">
                                    <p className={`hidden md:block font-semibold text-sm md:text-base truncate ${team1Lost ? 'text-gray-500' : 'text-white'}`}>{team1Data.name}</p>
                                    <p className="text-xs text-gray-400">{team1Data.teamtag}</p>
                                </div>
                            </>
                        ) : (
                            <div className="text-left text-gray-400 text-sm">{match.team1}</div>
                        )}
                    </div>

                    <div className="flex items-center gap-2 md:gap-4 px-2 md:px-6 flex-shrink-0">
                        <span className="text-xl md:text-2xl font-bold text-white w-6 md:w-8 text-center">{match.score1 !== null ? match.score1 : 0}</span>
                        <span className="text-gray-400">-</span>
                        <span className="text-xl md:text-2xl font-bold text-white w-6 md:w-8 text-center">{match.score2 !== null ? match.score2 : 0}</span>
                    </div>

                    <div className={`flex-1 flex items-center justify-end gap-2 md:gap-3 ${team2Lost ? 'opacity-50' : ''}`}>
                        {team2Data ? (
                            <>
                                <div className="text-right min-w-0">
                                    <p className={`hidden md:block font-semibold text-sm md:text-base truncate ${team2Lost ? 'text-gray-500' : 'text-white'}`}>{team2Data.name}</p>
                                    <p className="text-xs text-gray-400">{team2Data.teamtag}</p>
                                </div>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/equipes/${team2Data.logo}`}
                                    alt={team2Data.name}
                                    className="w-8 h-8 md:w-12 md:h-12 rounded-md object-contain flex-shrink-0"
                                    onError={(e) => e.target.style.display = 'none'}
                                />
                            </>
                        ) : (
                            <div className="text-right text-gray-400">{match.team2}</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

MatchCalendar.propTypes = {
    match: PropTypes.object.isRequired,
    equipes: PropTypes.array.isRequired,
    winScore: PropTypes.number,
};

export default MatchCalendar;

